import SideBar from "../sidebar/SideBar";
import Header from "../header/Header";
import { Link } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import { useState } from "react";
import { FaCirclePlus, FaCircleMinus, FaPlus } from "react-icons/fa6";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { useQuery } from "@tanstack/react-query";
import { getUsers } from "../../lib/user";
import AddQuotesForExistUser from "./addQuotesForExistUser";
import AddQuotesForNewUser from "./addQuotesForNewUser";
import { getSettings } from "../../lib/setting";

function AddressFormadmin() {
  const obj = {
    ative: true,
    content: "Book Shipment",
  };

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone();
  const [formCount, setFormCount] = useState(0);

  const [showInvoice, setShowInvoice] = useState(false);

  const [showForm, setShowForm] = useState(true);

  const handleButtonClick = (buttonType) => {
    if (buttonType === "form") {
      setShowForm(true);
      setShowInvoice(false);
    } else if (buttonType === "invoice") {
      setShowForm(false);
      setShowInvoice(true);
    }
  };

  const handlePlusClick = () => {
    setFormCount(formCount + 1);
  };

  const handleMinusClick = () => {
    setFormCount(formCount - 1);
  };

  const [inputSets, setInputSets] = useState(1);

  const handleAddSet = () => {
    setInputSets((prevSets) => prevSets + 1);
  };

  const [isDropdownOpen, setDropdownOpen] = useState(false);
  // console.log(nextQuoteNumber)
  const { data: settingsData, isLoading: settingsLoading } = useQuery(
    ["settings"],
    getSettings,
    {
      refetchOnWindowFocus: false,
    }
  );
  return (
    <>
      <div className="w-full border border-red">
        <div className="p-4 bg-cus-gray">
          <div className="p-4 mx-auto bg-white border rounded-md">
            <div className="">
              <div>
                <input
                  type="radio"
                  id="existing_customer_radio"
                  name="customer_type"
                  value="existing"
                  className="mr-2"
                  checked={showForm}
                  onChange={() => handleButtonClick("form")}
                />
                <label htmlFor="existing_customer_radio" className="mr-4 cursor-pointer">
                  Existing Customer
                </label>

                <input
                  type="radio"
                  id="new_customer_radio"
                  name="customer_type"
                  value="new"
                  checked={showInvoice}
                  onChange={() => handleButtonClick("invoice")}
                  className="mr-2"
                />
                <label htmlFor="new_customer_radio" className="mr-4 cursor-pointer">
                  New Customer
                </label>
              </div>

              <div>
                {showForm && (
                  <>
                    <AddQuotesForExistUser settingsData={settingsData} />
                    {/* <div className="mx-[30px] flex flex-col gap-1 py-2">
                      <label
                        className="w-full text-sm font-normal "
                        htmlFor="name"
                      >
                        Customer Name
                      </label>
                      <select className="w-full h-8 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue">
                        <option>Name 1</option>
                        <option>Name 2</option>
                        <option>Name 3</option>
                      </select>
                    </div>

                    <div>
                      <div className="mx-[30px] ">
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="country"
                          >
                            Load Address
                          </label>
                          <input
                            type="text"
                            placeholder="Street 23, new town"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="country"
                          />
                        </div>
                      </div>

                      <div className="mx-[30px] grid md:grid-cols-3 grid-cols-1 gap-3">
                        <div className="flex flex-col gap-1 py-2">
                          <select
                            className="w-full h-8 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="country"
                          >
                            <option value="option1">Option 1</option>
                            <option value="option2">Option 2</option>
                            <option value="option3">Option 3</option>
                          </select>
                        </div>
                        <div className="flex flex-col gap-1 py-2 ">
                          <select className="w-full h-8 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue">
                            <option>City 1</option>
                            <option>City 2</option>
                            <option>City 3</option>
                          </select>
                        </div>
                        <div className="flex flex-col gap-1 py-2">
                          <input
                            type="number"
                            placeholder="Postal Code"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="Mblenum"
                          />
                        </div>
                      </div>

                      <div className="mx-[30px] ">
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="country"
                          >
                            Unload Address
                          </label>
                          <input
                            type="text"
                            placeholder="Street 23, new town"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="country"
                          />
                        </div>
                      </div>

                      <div className="mx-[30px] grid md:grid-cols-3 grid-cols-1 gap-3">
                        <div className="flex flex-col gap-1 py-2">
                          <select
                            className="w-full h-8 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="country"
                          >
                            <option value="option1">Option 1</option>
                            <option value="option2">Option 2</option>
                            <option value="option3">Option 3</option>
                          </select>
                        </div>
                        <div className="flex flex-col gap-1 py-2 ">
                          <select className="w-full h-8 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue">
                            <option>City 1</option>
                            <option>City 2</option>
                            <option>City 3</option>
                          </select>
                        </div>
                        <div className="flex flex-col gap-1 py-2">
                          <input
                            type="number"
                            placeholder="Postal Code"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="Mblenum"
                          />
                        </div>
                      </div>

                      <div className="mx-[30px]">
                        <div className="flex flex-col gap-1 py-2 ">
                          <select className="w-full h-8 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue">
                            <option>Air</option>
                            <option>Air</option>
                            <option>Air</option>
                          </select>
                        </div>
                      </div>

                      <div className="mx-[30px] grid  grid-cols-1 md:grid-cols-2 gap-3">
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="country"
                          >
                            Cargo Value
                          </label>
                          <input
                            type="text"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="country"
                          />
                        </div>
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="country"
                          >
                            CIF Value
                          </label>
                          <input
                            type="text"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="country"
                          />
                        </div>
                      </div>

                      <h2 className="mx-[30px] font-bold text-xl mt-4">
                        Goods
                      </h2>

                      <div className="mx-[30px] grid  grid-cols-1 md:grid-cols-2 gap-3">
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="country"
                          >
                            Pcs Package<span className="text-[red] ">*</span>
                          </label>
                          <input
                            type="text"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="country"
                          />
                        </div>
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="country"
                          >
                            Weight<span className="text-[red] ">*</span>
                          </label>
                          <input
                            type="number"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="country"
                          />
                        </div>
                      </div>

                      <div className="mx-[30px] grid md:grid-cols-3 grid-cols-1 gap-3">
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="country"
                          >
                            Length<span className="text-[red] ">*</span>
                          </label>
                          <input
                            type="text"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="country"
                          />
                        </div>
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="country"
                          >
                            Weight<span className="text-[red] ">*</span>
                          </label>
                          <input
                            type="number"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="country"
                          />
                        </div>
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="country"
                          >
                            Height<span className="text-[red] ">*</span>
                          </label>
                          <input
                            type="number"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="country"
                          />
                        </div>
                      </div>

                      <div className="mx-[30px] flex flex-col gap-1 py-2">
                        <label
                          className="w-full text-sm font-normal "
                          htmlFor="country"
                        >
                          Description<span className="text-[red] ">*</span>
                        </label>
                        <textarea
                          placeholder="Description"
                          className="w-full h-[150px] p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                          id="country"
                        />
                      </div>

                      <h2 className="mx-[30px] font-bold text-xl mt-4">
                        Services
                      </h2>

                      {[...Array(inputSets)].map((_, index) => (
                        <div className="flex flex-col lg:flex-row gap-3 mx-[30px] ">
                          <div className=" w-full lg:w-[20%] flex flex-col gap-1 py-2">
                            <label
                              className="w-full text-sm font-normal "
                              htmlFor="country"
                            >
                              Number
                            </label>
                            <input
                              type="number"
                              className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                              id="country"
                            />
                          </div>
                          <div className=" w-full lg:w-[60%] flex flex-col gap-1 py-2">
                            <label
                              className="w-full text-sm font-normal "
                              htmlFor="country"
                            >
                              Description
                            </label>
                            <input
                              type="number"
                              className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                              id="country"
                            />
                          </div>
                          <div className=" w-full lg:w-[10%] flex flex-col gap-1 py-2">
                            <label
                              className="w-full text-sm font-normal "
                              htmlFor="country"
                            >
                              Price
                            </label>
                            <input
                              type="number"
                              className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                              id="country"
                            />
                          </div>
                          <div className=" w-full lg:w-[10%] flex flex-col gap-1 py-2">
                            <label
                              className="w-full text-[gray] text-sm font-normal "
                              htmlFor="country"
                            >
                              excl.VAT
                            </label>
                            <input
                              type="number"
                              className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                              id="country"
                            />
                          </div>
                          <div>
                            <h1 className="mt-2">Total</h1>

                            <p className="mt-3 text-[gray] ">&300.0</p>
                          </div>
                        </div>
                      ))}

                      <div className="mx-[30px] flex flex-col lg:flex-row gap-2 ">
                        <div className="w-full lg:w-[60%] bg-[#FBFCFF] p-4 rounded-lg  border border-cus-blue ">
                          <h1 className=" text-[16px] font-bold ">
                            Transport Warehouse - Hoofdrop
                          </h1>

                          <p className="text-[gray] ">
                            Selling Price: $0.00 excl VAT
                          </p>
                        </div>

                        <div className="w-full lg:w-[40%] bg-[#FBFCFF] p-4 border rounded-lg border-cus-blue">
                          <div className="flex justify-between">
                            <div>
                              <p className="text-[14px]">Total Excl.VAT</p>
                            </div>

                            <div className="">
                              <p className="text-[14px] font-extrabold ">
                                $44,88.00
                              </p>
                            </div>
                          </div>

                          <div className="flex justify-between mt-1 ">
                            <div>
                              <p className="text-[14px]">Total VAT Height</p>
                            </div>

                            <div className="">
                              <p className="text-[14px] font-extrabold ">
                                $44,88.00
                              </p>
                            </div>
                          </div>

                          <div className="flex justify-between mt-4 border-t border-cus-blue ">
                            <div className="mt-2">
                              <p className="text-[14px]">To Pay</p>
                            </div>

                            <div className="mt-2">
                              <p className="text-[14px] font-extrabold ">
                                $44,88.00
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="mx-[30px] mt-3 " onClick={handleAddSet}>
                        <FaPlus className="text-[20px] text-[#03336E] " />
                      </div>

                      <div className="mx-[30px] flex flex-col gap-3 sm:flex-row justify-between mt-4 ">
                        <button className="px-8 py-2 bg-[#03336E] rounded-lg text-[#fff] ">
                          Save
                        </button>
                        <button className="px-10 py-2 border rounded-lg border-[#9C9C9C] ">
                          Generated pdf
                        </button>
                      </div>
                    </div> */}
                  </>
                )}

                {showInvoice && (
                  <>
                    <AddQuotesForNewUser settingsData={settingsData} />
                    {/* <div>
                      <h2 className="mx-[30px] font-bold text-xl mt-4">
                        New Customer{" "}
                      </h2>
                      <div className=" mx-[30px] grid md:grid-cols-2 grid-cols-1 gap-3">
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="name"
                          >
                            Name
                          </label>
                          <input
                            type="text"
                            placeholder="Name"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="name"
                          />
                        </div>
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="companyname"
                          >
                            Email Address
                          </label>
                          <input
                            type="text"
                            placeholder="Email Address"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="companyname"
                          />
                        </div>
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="addressone"
                          >
                            Postal Code
                          </label>
                          <input
                            type="number"
                            placeholder="Postal Code"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="addressone"
                          />
                        </div>
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="addresstwo"
                          >
                            House No
                          </label>
                          <input
                            type="text"
                            placeholder="House No"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="addresstwo"
                          />
                        </div>
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="country"
                          >
                            Place
                          </label>
                          <input
                            type="text"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="country"
                          />
                        </div>
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal"
                            htmlFor="country"
                          >
                            Country
                          </label>
                          <select
                            className="w-full h-8 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="country"
                          >
                            <option value="option1">Option 1</option>
                            <option value="option2">Option 2</option>
                            <option value="option3">Option 3</option>
                          </select>
                        </div>
                      </div>

                      <div className="mx-[30px] ">
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="country"
                          >
                            Load Address
                          </label>
                          <input
                            type="text"
                            placeholder="Street 23, new town"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="country"
                          />
                        </div>
                      </div>

                      <div className="mx-[30px] grid md:grid-cols-3 grid-cols-1 gap-3">
                        <div className="flex flex-col gap-1 py-2">
                          <select
                            className="w-full h-8 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="country"
                          >
                            <option value="option1">Option 1</option>
                            <option value="option2">Option 2</option>
                            <option value="option3">Option 3</option>
                          </select>
                        </div>
                        <div className="flex flex-col gap-1 py-2 ">
                          <select className="w-full h-8 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue">
                            <option>City 1</option>
                            <option>City 2</option>
                            <option>City 3</option>
                          </select>
                        </div>
                        <div className="flex flex-col gap-1 py-2">
                          <input
                            type="number"
                            placeholder="Postal Code"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="Mblenum"
                          />
                        </div>
                      </div>

                      <div className="mx-[30px] ">
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="country"
                          >
                            Unload Address
                          </label>
                          <input
                            type="text"
                            placeholder="Street 23, new town"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="country"
                          />
                        </div>
                      </div>

                      <div className="mx-[30px] grid md:grid-cols-3 grid-cols-1 gap-3">
                        <div className="flex flex-col gap-1 py-2">
                          <select
                            className="w-full h-8 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="country"
                          >
                            <option value="option1">Option 1</option>
                            <option value="option2">Option 2</option>
                            <option value="option3">Option 3</option>
                          </select>
                        </div>
                        <div className="flex flex-col gap-1 py-2 ">
                          <select className="w-full h-8 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue">
                            <option>City 1</option>
                            <option>City 2</option>
                            <option>City 3</option>
                          </select>
                        </div>
                        <div className="flex flex-col gap-1 py-2">
                          <input
                            type="number"
                            placeholder="Postal Code"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="Mblenum"
                          />
                        </div>
                      </div>

                      <div className="mx-[30px]">
                        <div className="flex flex-col gap-1 py-2 ">
                          <select className="w-full h-8 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue">
                            <option>Air</option>
                            <option>Air</option>
                            <option>Air</option>
                          </select>
                        </div>
                      </div>

                      <div className="mx-[30px] grid  grid-cols-1 md:grid-cols-2 gap-3">
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="country"
                          >
                            Cargo Value
                          </label>
                          <input
                            type="text"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="country"
                          />
                        </div>
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="country"
                          >
                            CIF Value
                          </label>
                          <input
                            type="text"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="country"
                          />
                        </div>
                      </div>

                      <h2 className="mx-[30px] font-bold text-xl mt-4">
                        Goods
                      </h2>

                      <div className="mx-[30px] grid  grid-cols-1 md:grid-cols-2 gap-3">
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="country"
                          >
                            Pcs Package<span className="text-[red] ">*</span>
                          </label>
                          <input
                            type="text"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="country"
                          />
                        </div>
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="country"
                          >
                            Weight<span className="text-[red] ">*</span>
                          </label>
                          <input
                            type="number"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="country"
                          />
                        </div>
                      </div>

                      <div className="mx-[30px] grid md:grid-cols-3 grid-cols-1 gap-3">
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="country"
                          >
                            Length<span className="text-[red] ">*</span>
                          </label>
                          <input
                            type="text"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="country"
                          />
                        </div>
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="country"
                          >
                            Weight<span className="text-[red] ">*</span>
                          </label>
                          <input
                            type="number"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="country"
                          />
                        </div>
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="country"
                          >
                            Height<span className="text-[red] ">*</span>
                          </label>
                          <input
                            type="number"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="country"
                          />
                        </div>
                      </div>

                      <div className="mx-[30px] flex flex-col gap-1 py-2">
                        <label
                          className="w-full text-sm font-normal "
                          htmlFor="country"
                        >
                          Description<span className="text-[red] ">*</span>
                        </label>
                        <textarea
                          placeholder="Description"
                          className="w-full h-[150px] p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                          id="country"
                        />
                      </div>

                      <h2 className="mx-[30px] font-bold text-xl mt-4">
                        Services
                      </h2>

                      {[...Array(inputSets)].map((_, index) => (
                        <div className="flex flex-col lg:flex-row gap-3 mx-[30px] ">
                          <div className=" w-full lg:w-[20%] flex flex-col gap-1 py-2">
                            <label
                              className="w-full text-sm font-normal "
                              htmlFor="country"
                            >
                              Number
                            </label>
                            <input
                              type="number"
                              className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                              id="country"
                            />
                          </div>
                          <div className=" w-full lg:w-[60%] flex flex-col gap-1 py-2">
                            <label
                              className="w-full text-sm font-normal "
                              htmlFor="country"
                            >
                              Description
                            </label>
                            <input
                              type="number"
                              className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                              id="country"
                            />
                          </div>
                          <div className=" w-full lg:w-[10%] flex flex-col gap-1 py-2">
                            <label
                              className="w-full text-sm font-normal "
                              htmlFor="country"
                            >
                              Price
                            </label>
                            <input
                              type="number"
                              className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                              id="country"
                            />
                          </div>
                          <div className=" w-full lg:w-[10%] flex flex-col gap-1 py-2">
                            <label
                              className="w-full text-[gray] text-sm font-normal "
                              htmlFor="country"
                            >
                              excl.VAT
                            </label>
                            <input
                              type="number"
                              className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                              id="country"
                            />
                          </div>
                          <div>
                            <h1 className="mt-2">Total</h1>

                            <p className="mt-3 text-[gray] ">&300.0</p>
                          </div>
                        </div>
                      ))}

                      <div className="mx-[30px] flex flex-col lg:flex-row gap-2 ">
                        <div className="w-full lg:w-[60%] bg-[#FBFCFF] p-4 rounded-lg  border border-cus-blue ">
                          <h1 className=" text-[16px] font-bold ">
                            Transport Warehouse - Hoofdrop
                          </h1>

                          <p className="text-[gray] ">
                            Selling Price: $0.00 excl VAT
                          </p>
                        </div>

                        <div className="w-full lg:w-[40%] bg-[#FBFCFF] p-4 border rounded-lg border-cus-blue">
                          <div className="flex justify-between">
                            <div>
                              <p className="text-[14px]">Total Excl.VAT</p>
                            </div>

                            <div className="">
                              <p className="text-[14px] font-extrabold ">
                                $44,88.00
                              </p>
                            </div>
                          </div>

                          <div className="flex justify-between mt-1 ">
                            <div>
                              <p className="text-[14px]">Total VAT Height</p>
                            </div>

                            <div className="">
                              <p className="text-[14px] font-extrabold ">
                                $44,88.00
                              </p>
                            </div>
                          </div>

                          <div className="flex justify-between mt-4 border-t border-cus-blue ">
                            <div className="mt-2">
                              <p className="text-[14px]">To Pay</p>
                            </div>

                            <div className="mt-2">
                              <p className="text-[14px] font-extrabold ">
                                $44,88.00
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="mx-[30px] mt-3 " onClick={handleAddSet}>
                        <FaPlus className="text-[20px] text-[#03336E] " />
                      </div>

                      <div className="mx-[30px] flex flex-col gap-3 sm:flex-row justify-between mt-4 ">
                        <button className="px-8 py-2 bg-[#03336E] rounded-lg text-[#fff] ">
                          Save
                        </button>
                        <button className="px-10 py-2 border rounded-lg border-[#9C9C9C] ">
                          Generated pdf
                        </button>
                      </div>
                    </div> */}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddressFormadmin;
